import {createFileRoute, redirect} from '@tanstack/react-router';
import MedicationRequestList from '@/patient/views/medicationRequest/MedicationRequestList';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

export const Route = createFileRoute('/(patient)/medication-requests')({
  component: MedicationRequestList,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.isPatient && context.company?.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
